import { render, staticRenderFns } from "./SocialBtns.vue?vue&type=template&id=3cb28fc8&lang=pug&"
import script from "./SocialBtns.vue?vue&type=script&lang=js&"
export * from "./SocialBtns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports